define("shared/components/shared-ig-media-card", ["exports", "@ember/component", "@ember/template-factory"], function (_exports, _component, _templateFactory) {
  "use strict";

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports.default = void 0;
  0; //eaimeta@70e063a35619d71f0,"@ember/component",0,"@ember/template-factory"eaimeta@70e063a35619d71f

  const __COLOCATED_TEMPLATE__ = (0, _templateFactory.createTemplateFactory)(
  /*
    <div class="o--cardContainer tCO--card qa--cardContainer">
    <div
      class="o--card"
      onclick={{action openDetails media}}
    >
      <figure class="o--mediaContainer">
        {{#if media.isCarouselPost}}
          <span class="o--media__label--type">
            {{svg-jar "gallery" class="o--icon--md"}}
          </span>
          {{#each (take 1 media.carouselMediaItems) as |firstMedia|}}
            {{#if (is-equal firstMedia.type "video")}}
              <video
                src={{firstMedia.lowBandwidthVideoUrl}}
                class="o--media"
                preload="metadata"
              ></video>
            {{/if}}
          {{/each}}
        {{/if}}
        {{#if media.isVideo}}
          <Shared::Ui::Video
            class="o--media"
            @src={{media.lowBandwidthVideoUrl}}
            @controls={{false}}
          />
          {{#unless media.isCarouselPost}}
            <span class="o--media__label--type">
              {{svg-jar "video" class="o--icon--md"}}
            </span>
          {{/unless}}
        {{else}}
          <img
            src={{media.secureLowResUrl}}
            alt={{media.caption}}
            class="o--media"
          >
          <b class="o--mediaOverlay"></b>
        {{/if}}
      </figure>
      <div class="cCS--card__info o--card__content">
        <div class="o--card__desc--truncate">
          {{#if media.caption}}
            <span class="e--media_caption">
              {{media.caption}}
            </span>
          {{/if}}
        </div>
        <div class="o--card__footer">
          <div class="u--float--left">
            <span class="u--m__r__sm u--text--sm qa--searchProfile_media_likes">
              {{#if media.userHasLiked}}
                {{svg-jar "liked" class="o--icon--sm is--liked"}}
              {{else}}
                {{svg-jar "like" class="o--icon--sm"}}
              {{/if}}
              {{format-number-with-suffix media.likeCount}}
            </span>
            <span class="u--m__r__sm u--text--sm qa--searchProfile_media_cmnts">
              {{svg-jar "comment" class="o--icon--sm"}}
              {{format-number-with-suffix media.commentCount}}
            </span>
          </div>
        </div>
      </div>
    </div>
  </div>
  
  */
  {
    "id": "x+TagrVx",
    "block": "[[[10,0],[14,0,\"o--cardContainer tCO--card qa--cardContainer\"],[12],[1,\"\\n  \"],[10,0],[14,0,\"o--card\"],[15,\"onclick\",[28,[37,0],[[30,0],[33,1],[33,2]],null]],[12],[1,\"\\n    \"],[10,\"figure\"],[14,0,\"o--mediaContainer\"],[12],[1,\"\\n\"],[41,[33,2,[\"isCarouselPost\"]],[[[1,\"        \"],[10,1],[14,0,\"o--media__label--type\"],[12],[1,\"\\n          \"],[1,[28,[35,4],[\"gallery\"],[[\"class\"],[\"o--icon--md\"]]]],[1,\"\\n        \"],[13],[1,\"\\n\"],[42,[28,[37,6],[[28,[37,6],[[28,[37,7],[1,[33,2,[\"carouselMediaItems\"]]],null]],null]],null],null,[[[41,[28,[37,8],[[30,1,[\"type\"]],\"video\"],null],[[[1,\"            \"],[10,\"video\"],[15,\"src\",[30,1,[\"lowBandwidthVideoUrl\"]]],[14,0,\"o--media\"],[14,\"preload\",\"metadata\"],[12],[13],[1,\"\\n\"]],[]],null]],[1]],null]],[]],null],[41,[33,2,[\"isVideo\"]],[[[1,\"        \"],[8,[39,9],[[24,0,\"o--media\"]],[[\"@src\",\"@controls\"],[[33,2,[\"lowBandwidthVideoUrl\"]],false]],null],[1,\"\\n\"],[41,[51,[33,2,[\"isCarouselPost\"]]],[[[1,\"          \"],[10,1],[14,0,\"o--media__label--type\"],[12],[1,\"\\n            \"],[1,[28,[35,4],[\"video\"],[[\"class\"],[\"o--icon--md\"]]]],[1,\"\\n          \"],[13],[1,\"\\n\"]],[]],null]],[]],[[[1,\"        \"],[10,\"img\"],[15,\"src\",[33,2,[\"secureLowResUrl\"]]],[15,\"alt\",[33,2,[\"caption\"]]],[14,0,\"o--media\"],[12],[13],[1,\"\\n        \"],[10,\"b\"],[14,0,\"o--mediaOverlay\"],[12],[13],[1,\"\\n\"]],[]]],[1,\"    \"],[13],[1,\"\\n    \"],[10,0],[14,0,\"cCS--card__info o--card__content\"],[12],[1,\"\\n      \"],[10,0],[14,0,\"o--card__desc--truncate\"],[12],[1,\"\\n\"],[41,[33,2,[\"caption\"]],[[[1,\"          \"],[10,1],[14,0,\"e--media_caption\"],[12],[1,\"\\n            \"],[1,[33,2,[\"caption\"]]],[1,\"\\n          \"],[13],[1,\"\\n\"]],[]],null],[1,\"      \"],[13],[1,\"\\n      \"],[10,0],[14,0,\"o--card__footer\"],[12],[1,\"\\n        \"],[10,0],[14,0,\"u--float--left\"],[12],[1,\"\\n          \"],[10,1],[14,0,\"u--m__r__sm u--text--sm qa--searchProfile_media_likes\"],[12],[1,\"\\n\"],[41,[33,2,[\"userHasLiked\"]],[[[1,\"              \"],[1,[28,[35,4],[\"liked\"],[[\"class\"],[\"o--icon--sm is--liked\"]]]],[1,\"\\n\"]],[]],[[[1,\"              \"],[1,[28,[35,4],[\"like\"],[[\"class\"],[\"o--icon--sm\"]]]],[1,\"\\n\"]],[]]],[1,\"            \"],[1,[28,[35,11],[[33,2,[\"likeCount\"]]],null]],[1,\"\\n          \"],[13],[1,\"\\n          \"],[10,1],[14,0,\"u--m__r__sm u--text--sm qa--searchProfile_media_cmnts\"],[12],[1,\"\\n            \"],[1,[28,[35,4],[\"comment\"],[[\"class\"],[\"o--icon--sm\"]]]],[1,\"\\n            \"],[1,[28,[35,11],[[33,2,[\"commentCount\"]]],null]],[1,\"\\n          \"],[13],[1,\"\\n        \"],[13],[1,\"\\n      \"],[13],[1,\"\\n    \"],[13],[1,\"\\n  \"],[13],[1,\"\\n\"],[13],[1,\"\\n\"]],[\"firstMedia\"],false,[\"action\",\"openDetails\",\"media\",\"if\",\"svg-jar\",\"each\",\"-track-array\",\"take\",\"is-equal\",\"shared/ui/video\",\"unless\",\"format-number-with-suffix\"]]",
    "moduleName": "shared/components/shared-ig-media-card.hbs",
    "isStrictMode": false
  });

  var _default = (0, _component.setComponentTemplate)(__COLOCATED_TEMPLATE__, _component.default.extend({}));

  _exports.default = _default;
});